<div class="user-panel">

  <!-- Trigger button -->
  <div class="up-trigger" (click)="toggleDropdown(); $event.stopPropagation()">
    <img [src]="profileImage || 'assets/icons/imgpreview.png'" class="up-trigger-img" alt="Profile" />
  </div>

  <!-- Custom dropdown -->
  <div class="up-dropdown" *ngIf="dropdownOpen" (click)="$event.stopPropagation()">

    <ng-container *ngFor="let item of menuItems">

      <!-- Skip language menu item — rendered separately below -->
      <ng-container *ngIf="!item.isLanguageMenu">

        <!-- Profile row -->
        <div *ngIf="item.isProfile" class="up-row" (click)="handleItemClick(item)">
          <img [src]="profileImage || 'assets/icons/imgpreview.png'" class="up-profile-img" alt="Profile" />
          <span class="up-text">{{ item.text }}</span>
        </div>

        <!-- Disabled row (e.g. Version) -->
        <div *ngIf="!item.isProfile && item.disabled" class="up-row up-row-disabled">
          <i *ngIf="item.icon" class="dx-icon dx-icon-{{ item.icon }}"></i>
          <span class="up-text">{{ item.text }}</span>
        </div>

        <!-- Regular clickable row -->
        <div *ngIf="!item.isProfile && !item.disabled" class="up-row" (click)="handleItemClick(item)">
          <i *ngIf="item.icon" class="dx-icon dx-icon-{{ item.icon }}"></i>
          <span class="up-text">{{ item.text }}</span>
        </div>

      </ng-container>

    </ng-container>

    <!-- Language row with hover flyout -->
    <div class="up-lang-wrapper">
      <div class="up-row up-lang-row">
        <i class="dx-icon dx-icon-globe"></i>
        <span class="up-text">{{ langService.currentLang === 'mr' ? 'भाषा' : 'Language' }}</span>
        <span class="up-chevron">›</span>
      </div>

      <!-- Side flyout — CSS hover -->
      <div class="up-lang-flyout" (click)="$event.stopPropagation()">
        <div class="up-lang-option"
          [class.up-lang-active]="langService.currentLang === 'en'"
          (click)="selectLang('en')">
          English
        </div>
        <div class="up-lang-option"
          [class.up-lang-active]="langService.currentLang === 'mr'"
          (click)="selectLang('mr')">
          मराठी
        </div>
      </div>
    </div>

  </div>

</div>